import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"


function Home() {
  const location = useLocation()
  const { pathname } = location
  const { compName } = useSelector((state) => state.company)

  const [msg, setMsg] = useState("")

  useEffect(() => {
    if (pathname == "/dashboard/trading-dashboard")
      setMsg("")
    else setMsg("You are Not Authorized")
  }, [pathname])
  return (
    <div>
      {/* {msg != "" ? <div> {msg} </div> : */}

        <div className="min-h-screen bg-gradient-to-r from-slate-100 to-sky-50 flex items-top justify-center">
          <div className=" pt-10 text-center max-w-xl w-full">

            <h1 className="text-3xl font-extrabold text-sky-600 ">
              {compName}
            </h1>



            {/* <button className="bg-indigo-600 text-white px-6 py-2 rounded-lg hover:bg-indigo-700 transition">
          Explore Now
        </button> */}

          </div>
        </div>

      
    </div>
  )
}
export default Home